import { PickupParticipantDetailPage } from "components/shared/pickupParticipants";
import { InformationSection } from "../../components/DetailForm/InformationSection";
import { PickupInformationSection } from "../../components/DetailForm/PickupInformationSection";
import { RegistrationInformationSection } from "../../components/DetailForm/RegistrationInformationSection";

const WPSCheckinSportParticipantsDetailPage = () => (
  <PickupParticipantDetailPage
    kind="sport"
    variant="wps"
    sections={{
      InformationSection,
      RegistrationInformationSection,
      PickupInformationSection,
    }}
  />
);

export default WPSCheckinSportParticipantsDetailPage;
